export const AFFILIATE_PROFILE_SUBAFFILIATE_ROUTE_NAME = Symbol('admin.affiliates.approved.profile.subaffiliate');
export const TRANSLATION_GROUP_AFFILIATE_PROFILE_SUBAFFILIATE = Symbol('admin.affiliates.approved.profile.subaffiliate');
